import { API_BASE_URL } from "../constant";

export const createCompany = (data) =>
  API_BASE_URL.post("company", data);

export const createForm = (data) =>
  API_BASE_URL.post("company/form", data);
export const getAllCompanies = (data) =>
  API_BASE_URL.get("company", data);
export const getCompanyById = (companyId) =>
  API_BASE_URL.get(`company/${companyId}`);
export const updateCompany = (data, companyId) =>
  API_BASE_URL.patch(`company/${companyId}`, data);
export const updateCompanyProfile = (data, companyId) =>
  API_BASE_URL.put(`company/profile/${companyId}`, data);
export const deleteCompany = (companyId) =>
  API_BASE_URL.delete(`company/${companyId}`);
export const disableCompany = (companyId) =>
  API_BASE_URL.put(`company/disable/${companyId}`);

export const postSubmissionFile = (companyId, employeeId, formData) => API_BASE_URL.post(`submission/upload/${companyId}`, formData, {
  params: { employeeId }
});